import React, { useEffect, useState } from "react";
import SkeletonTable from "../../../components/table/SkeletonTable";
import columns from "../../../columns/reviewDoc/viewReviewDoc.js";
import { GetOrganizerAnswerApi } from "../../../api/request/taskManager/taskManager.js";
import { Spin } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import PdfLink from "../../../components/common/PdfLink.jsx";
import ViewFilesModal from "../../reviewDoc/components/ViewFilesModal.jsx";
import moment from "moment";

export default function OrganizerReportReview() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [clientData, setClientData] = useState({});
  const [selectedQuestion, setSelectedQuestion] = useState({});
  const [isFilesOpen, setIsFilesOpen] = useState(false);

  const tableColumns = columns?.filter((col) => col?.dataIndex !== "review");
  const displayDate = clientData?.submitted_date || clientData?.created_at;
  const formattedDate = displayDate ? moment(displayDate).format("lll") : "--";

  const getQuestions = async () => {
    try {
      setIsLoading(true);
      const { data } = await GetOrganizerAnswerApi({ organizer_id: id });
      if (data?.status) {
        setClientData(data?.client_selected_org);
        setData(
          data?.data?.map((section) => {
            return {
              ...section,
              questions: section?.questions?.map((question) => {
                const hasDocuments = Boolean(question?.documents?.length);
                return {
                  ...question,
                  question: <div>{question?.field_label || "--"}</div>,
                  response_text: hasDocuments ? (
                    <a
                      onClick={() => {
                        setSelectedQuestion(question);
                        setIsFilesOpen(true);
                      }}
                      className="hover:text-primary text-primary underline underline-offset-4"
                      target="_blank"
                    >
                      View Files
                    </a>
                  ) : (
                    <div className="max-w-[250px] text-wrap">
                      {question?.response_text || "--"}
                    </div>
                  ),
                };
              }),
            };
          })
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getQuestions();
  }, []);

  return (
    <div className="mb-6">
      <div className="border-2 rounded-xl p-5">
        {isLoading ? (
          <div className="flex justify-center flex-col mt-[20%]">
            <Spin size="large" />
            <p className="primary text-center mt-2">Loading...</p>
          </div>
        ) : (
          <>
            <div className="flex justify-between gap-5 mb-5">
              <div>
                {clientData?.user && (
                  <div className="flex items-center gap-3">
                    <div>
                      <p className="font-semibold text-xl capitalize">
                        {clientData?.user?.name}
                      </p>
                      {clientData?.user?.email && (
                        <p className="text-gray-600">{clientData?.user?.email}</p>
                      )}
                    </div>
                    <p
                      className="text-blue-500 underline cursor-pointer"
                      onClick={() => navigate(`/client/${clientData?.user_id}`)}
                    >
                      View
                    </p>
                  </div>
                )}
              </div>
              {/* <div className="flex items-center gap-5">
                {clientData?.auth_pdf?.url && (
                  <PdfLink text={"Authorization"} data={clientData?.auth_pdf} />
                )}
                {clientData?.gst_pdf?.url && (
                  <PdfLink text={"GST"} data={clientData?.gst_pdf} />
                )}
              </div> */}
              <div className="flex flex-col items-end gap-2">
                 <div className="text-right">
                  <p className="font-semibold capitalize">
                    {clientData?.organizer_name_slug || "--"}
                  </p>
                  <p className="text-gray-600">{formattedDate}</p>
                </div>
                <div className="flex items-center gap-5">
                  {clientData?.organizer_pdf?.url && (
                    <PdfLink
                      text={"Tax Return Pdf"}
                      data={clientData?.organizer_pdf}
                    />
                  )}
                  {clientData?.organizer_spouse_pdf?.url && (
                    <PdfLink
                      text={"Spouse Tax Return Pdf"}
                      data={clientData?.organizer_spouse_pdf}
                    />
                  )}
                </div>
              </div>
            </div>

            {data?.map((item, index) => (
              <div className="table-radius-0 text-light mb-10" key={item?.id || index}>
                <p className="font-semibold text-xl text-primary mb-5">
                  {`Section ${index + 1}:`} {item?.section_name}
                </p>
                <SkeletonTable
                  columns={tableColumns}
                  data={item?.questions}
                  isLoading={isLoading}
                />
              </div>
            ))}
          </>
        )}
      </div>

      <ViewFilesModal
        isOpen={isFilesOpen}
        setIsOpen={setIsFilesOpen}
        question={selectedQuestion}
      />
    </div>
  );
}
